import { Grid2, Typography } from "@mui/material";
import React from "react";
export const Row = ({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) => (
  <Grid2 container mb={1}>
    <Grid2 size={{ xs: 6 }}>
      <Typography variant="body1">
        <b>{label}:</b>
      </Typography>
    </Grid2>
    <Grid2 size={{ xs: 6 }}>
      <Typography variant="body1">{value ?? "-"}</Typography>
    </Grid2>
  </Grid2>
);
